/* eslint-disable @typescript-eslint/naming-convention */

export interface ThemePreset {
  id: string;
  name: string;
  heroGradient: string;
  heroTextColor: string;
  pageBackground: string;
  cardBackground: string;
  cardBorder: string;
  accentColor: string;
  textColor: string;
}

export const DEFAULT_THEME: ThemePreset = {
  id: "classic",
  name: "Classic",
  heroGradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  heroTextColor: "#ffffff",
  pageBackground: "#f8f9fa",
  cardBackground: "#ffffff",
  cardBorder: "#f0f0f0",
  accentColor: "#667eea",
  textColor: "#333333",
};

export const THEME_PRESETS: ThemePreset[] = [
  DEFAULT_THEME,
  {
    id: "ocean",
    name: "Ocean",
    heroGradient: "linear-gradient(135deg, #0077B6 0%, #00B4D8 100%)",
    heroTextColor: "#ffffff",
    pageBackground: "#f0f8ff",
    cardBackground: "#ffffff",
    cardBorder: "#caf0f8",
    accentColor: "#0077B6",
    textColor: "#023e8a",
  },
  {
    id: "sunset",
    name: "Sunset",
    heroGradient: "linear-gradient(135deg, #f97316 0%, #ec4899 100%)",
    heroTextColor: "#ffffff",
    pageBackground: "#fff7ed",
    cardBackground: "#ffffff",
    cardBorder: "#fed7aa",
    accentColor: "#f97316",
    textColor: "#9a3412",
  },
  {
    id: "forest",
    name: "Forest",
    heroGradient: "linear-gradient(135deg, #2d6a4f 0%, #52b788 100%)",
    heroTextColor: "#ffffff",
    pageBackground: "#f0fdf4",
    cardBackground: "#ffffff",
    cardBorder: "#d8f3dc",
    accentColor: "#2d6a4f",
    textColor: "#1b4332",
  },
  {
    id: "elegantDark",
    name: "Elegant Dark",
    heroGradient: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
    heroTextColor: "#e0e0e0",
    pageBackground: "#0f0f1a",
    cardBackground: "#1a1a2e",
    cardBorder: "#2a2a3e",
    accentColor: "#e94560",
    textColor: "#e0e0e0",
  },
  {
    id: "playful",
    name: "Playful",
    heroGradient: "linear-gradient(135deg, #7c3aed 0%, #f472b6 50%, #facc15 100%)",
    heroTextColor: "#ffffff",
    pageBackground: "#faf5ff",
    cardBackground: "#ffffff",
    cardBorder: "#e9d5ff",
    accentColor: "#7c3aed",
    textColor: "#4c1d95",
  },
  {
    id: "minimal",
    name: "Minimal",
    heroGradient: "linear-gradient(135deg, #374151 0%, #6b7280 100%)",
    heroTextColor: "#ffffff",
    pageBackground: "#ffffff",
    cardBackground: "#ffffff",
    cardBorder: "#e5e7eb",
    accentColor: "#374151",
    textColor: "#111827",
  },
];

export function getThemeById(themeId?: string): ThemePreset {
  if (!themeId) return DEFAULT_THEME;
  return THEME_PRESETS.find((t) => t.id === themeId) || DEFAULT_THEME;
}
